class CacheService {
    constructor() {
    }

    cache(fn) {
        let cache = {};
        let pendingCache = {};
        let cacheFunc;

        cacheFunc = async function (...args) {
            const cacheKey = JSON.stringify(args);

            if (!cache[cacheKey]) {
                pendingCache[cacheKey] ??= fn(...args);
                cache[cacheKey] = await pendingCache[cacheKey];
                pendingCache[cacheKey] = undefined;
            }

            return cache[cacheKey];
        };

        const resetFunc = function () {
            cache = {};
        };

        return [cacheFunc, resetFunc];
    };
}

window.cacheService = new CacheService();